import { alpha, Theme } from '@mui/material/styles';
import { getViewerOverlaySurfaceStyles } from 'components/theme/theme';
import { getIsMultiStain } from 'interfaces/stainType';

export type SlideCarouselTone = 'brightfield' | 'multiplex';

export const getSlideCarouselTone = (slideStainingType?: string | null): SlideCarouselTone =>
  getIsMultiStain(slideStainingType ?? '') ? 'multiplex' : 'brightfield';

export const getSlideOverlayToneStyles = (theme: Theme, tone: SlideCarouselTone) =>
  tone === 'multiplex'
    ? {
        backgroundColor: alpha(theme.palette.common.black, theme.palette.mode === 'dark' ? 0.72 : 0.68),
        color: alpha(theme.palette.common.white, 0.9),
        border: `1px solid ${alpha(theme.palette.common.white, 0.18)}`,
      }
    : {
        backgroundColor: alpha(theme.palette.common.white, 0.72),
        color: theme.palette.common.black,
        border: `1px solid ${alpha(theme.palette.common.black, 0.12)}`,
      };

export const getSlideNavigationSurfaceStyles = (theme: Theme, tone: SlideCarouselTone) => {
  const overlaySurfaceStyles = getViewerOverlaySurfaceStyles(theme);
  const overlayToneStyles = getSlideOverlayToneStyles(theme, tone);

  return {
    ...overlaySurfaceStyles,
    ...overlayToneStyles,
    backgroundImage:
      tone === 'multiplex'
        ? `linear-gradient(180deg, ${alpha(theme.palette.common.white, 0.08)} 0%, ${alpha(
            theme.palette.common.white,
            0.02
          )} 100%)`
        : overlaySurfaceStyles.backgroundImage,
    boxShadow:
      tone === 'multiplex'
        ? theme.palette.mode === 'light'
          ? '0 10px 24px rgba(15, 23, 42, 0.14)'
          : '0 14px 32px rgba(0, 0, 0, 0.38)'
        : overlaySurfaceStyles.boxShadow,
  };
};
